module.exports = __webpack_public_path__ + "static/img/kr.60fde7fc.svg";